import React from "react";

export const Orders: React.FC<React.SVGAttributes<SVGSVGElement>> = ({
  stroke = "currentColor",
  fill = "currentColor",
  ...svgProps
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      stroke={stroke}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...svgProps}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
      <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
      <line x1="9" y1="7" x2="10" y2="7" />
      <line x1="9" y1="13" x2="15" y2="13" />
      <line x1="13" y1="17" x2="15" y2="17" />
    </svg>
  );
};
